import { useState, useRef, useEffect } from "react";

interface TooltipProps {
    content: string | React.ReactNode;
    children: React.ReactNode;
    position?: "top" | "bottom" | "left" | "right";
    className?: string;
}

export const Tooltip = ({
    content,
    children,
    position = "top",
    className = ""
}: TooltipProps) => {
    const [isVisible, setIsVisible] = useState(false);
    const tooltipRef = useRef<HTMLDivElement>(null);
    const triggerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isVisible && tooltipRef.current) {
            const tooltip = tooltipRef.current;

            // Reset styles first
            tooltip.style.top = "";
            tooltip.style.bottom = "";
            tooltip.style.left = "";
            tooltip.style.right = "";
            tooltip.style.transform = "";

            // Position the tooltip
            switch (position) {
                case "top":
                    tooltip.style.bottom = "100%";
                    tooltip.style.left = "50%";
                    tooltip.style.marginBottom = "8px";
                    tooltip.style.transform = "translateX(-50%)";
                    break;
                case "bottom":
                    tooltip.style.top = "100%";
                    tooltip.style.left = "50%";
                    tooltip.style.marginTop = "8px";
                    tooltip.style.transform = "translateX(-50%)";
                    break;
                case "left":
                    tooltip.style.right = "100%";
                    tooltip.style.top = "50%";
                    tooltip.style.marginRight = "8px";
                    tooltip.style.transform = "translateY(-50%)";
                    break;
                case "right":
                    tooltip.style.left = "100%";
                    tooltip.style.top = "50%";
                    tooltip.style.marginLeft = "8px";
                    tooltip.style.transform = "translateY(-50%)";
                    break;
            }
        }
    }, [isVisible, position]);

    return (
        <div
            className={`relative inline-block ${className}`}
            ref={triggerRef}
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {children}
            {isVisible && (
                <div
                    ref={tooltipRef}
                    className="absolute z-50 bg-white border border-stroke rounded-lg shadow-lg p-4"
                    style={{
                        pointerEvents: "none",
                        minWidth: "280px",
                        maxWidth: "400px",
                        width: "max-content",
                    }}
                >
                    {typeof content === "string" ? (
                        <p className="font-clash-display text-xs font-regular text-medium-dark-grey leading-relaxed">
                            {content}
                        </p>
                    ) : (
                        content
                    )}
                </div>
            )}
        </div>
    );
};

